import React from 'react';

/**
 * A top-level section. The mono path above the title matches the entry
 * in the sidebar tree, so the page and the navigation read as one
 * workspace.
 */
export const Section = ({ id, path, title, lede, children }) => (
  <section className="section" id={id}>
    <header className="section-head">
      <p className="section-path">{path}</p>
      <h2 className="section-title">{title}</h2>
      {lede && <p className="section-lede">{lede}</p>}
    </header>
    {children}
  </section>
);

export default Section;
